'use client';

import type { ReactNode } from 'react';
import { useEffect } from 'react';

import { ToastProvider } from '@ui';

import ThemeProvider from './ThemeProvider';
import ThemeQueryEffect from './ThemeQueryEffect';

type RootProvidersProps = Readonly<{
  children: ReactNode;
}>;

/**
 * Lightweight root client wrappers: scroll behavior + theme context + optional query-param theme sync +
 * toast context (matches typical child-app `Providers` layering).
 * App shell chrome (header / footer / main) stays in `template.tsx` or an app-local shell.
 */
export default function RootProviders({ children }: RootProvidersProps) {
  useEffect(() => {
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <ThemeProvider>
      <ThemeQueryEffect />
      <ToastProvider>{children}</ToastProvider>
    </ThemeProvider>
  );
}
